// extracted by mini-css-extract-plugin
export default {"categoryBadge":"category_badge-module___categoryBadge___fd23974c","categoryTitle":"category_badge-module___categoryTitle___e8059f2f"};